import moment from 'moment';
import * as ROUTES from '@/constants/routes.js';
import { ATTENTION_TIME_FIELDS } from '@/constants/time.js';

export const state = () => {
    const current = moment().valueOf();
    return {
        current,
        previous: current,
        last_active: current,
        [ATTENTION_TIME_FIELDS.BATCH_AWAITING]: 0,
        [ATTENTION_TIME_FIELDS[ROUTES.QUEUE]]: 0,
        [ATTENTION_TIME_FIELDS[ROUTES.SEARCH]]: 0,
        [ATTENTION_TIME_FIELDS[ROUTES.QUICK_SEARCH]]: 0,
        [ATTENTION_TIME_FIELDS[ROUTES.WORKSPACES]]: 0,
        [ATTENTION_TIME_FIELDS[ROUTES.NEW_WORKSPACE]]: 0,
        [ATTENTION_TIME_FIELDS[ROUTES.WORKSPACE]]: 0,
        [ATTENTION_TIME_FIELDS[ROUTES.CREATE_QUEUE]]: 0,
        [ATTENTION_TIME_FIELDS[ROUTES.NEW_QUEUE]]: 0,
        [ATTENTION_TIME_FIELDS[ROUTES.NEW_SEARCH]]: 0,
        is_inactive: false,
        event_history: [],
    };
};
